import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import { DashedContainer } from 'src/common/DashedContainer';
import { InfoCircleSvg } from 'src/assets/dynamicSvg';

// Standard dashed border. Colour #c6ccda (Figma 16886-881) — more contrast than the light stroke.
const Banner = styled(DashedContainer)`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px dashed #c6ccda;
  border-radius: 8px;
  padding: 8px 16px;
`;

export const NarrativeBanner: React.FC = () => (
  <Banner>
    <InfoCircleSvg gradient size={14} style={{ flexShrink: 0 }} />
    <Poppins px={14} color="prussianBlue" css="line-height: 1.7;">
      We&apos;ll help you set up your risk. You&apos;ll have full control to edit or fine-tune everything at the final
      step.
    </Poppins>
  </Banner>
);
